export const headerTeleportSlot = 'header-teleport-slot';
